export const OFFICE_DETAILS_CHANGE_TRACKING = {
  officeDetailsContract: {
    source: 'office_details.contract',
    id: 14001,
  },
  officeDetailsDocuments: {
    source: 'office_details.documents',
    id: 14002,
  },
  officeDetailsManageUsers: {
    source: 'office_details.manage_users',
    id: 14003,
  },
  officeDetailsOfficeDetails: {
    source: 'office_details.office_details',
    id: 14004,
  },
  officeDetailsCreate: {
    source: 'office_details.create',
    id: 14101,
  },
  officeDetailsCapacityGroupCreate: {
    source: 'office_details.capacity_groups.create',
    id: 14102,
  },
  officeDetailsCapacityGroupDelete: {
    source: 'office_details.capacity_groups.delete',
    id: 14103,
  },
  officeDetailsCapacityGroupUpdate: {
    source: 'office_details.capacity_groups.update',
    id: 14104,
  },
  officeDetailsDocumentsDelete: {
    source: 'office_details.documents.delete',
    id: 14105,
  },
  officeDetailsDocumentsUpload: {
    source: 'office_details.documents.upload',
    id: 14106,
  },
  officeDetailsGroupCreate: {
    source: 'office_details.groups.create',
    id: 14107,
  },
  officeDetailsGroupDelete: {
    source: 'office_details.groups.delete',
    id: 14108,
  },
  officeDetailsGroupUpdate: {
    source: 'office_details.groups.update',
    id: 14109,
  },
  officeDetailsUserActivate: {
    source: 'office_details.manage_users.activate',
    id: 14110,
  },
  officeDetailsUserAddRole: {
    source: 'office_details.manage_users.add_role',
    id: 14111,
  },
  officeDetailsUserCreate: {
    source: 'office_details.manage_users.create_user',
    id: 14112,
  },
  officeDetailsUserDeactivate: {
    source: 'office_details.manage_users.deactivate',
    id: 14113,
  },
  officeDetailsUserRemoveRole: {
    source: 'office_details.manage_users.remove_role',
    id: 14114,
  },
  postingGroupsCreate: {
    source: 'posting_groups.create',
    id: 14201,
  },
  postingGroupsDelete: {
    source: 'posting_groups.delete',
    id: 14202,
  },
  postingGroupsUpdate: {
    source: 'posting_groups.update',
    id: 14203,
  },
  postingGroupsUserAssign: {
    source: 'posting_groups.users.assign',
    id: 14204,
  },
  postingGroupsUserUnassign: {
    source: 'posting_groups.users.unassign',
    id: 14205,
  },
} as const;
